<template>
  <div class="home">
    <Swiper1></Swiper1>
    <div class="news">
      <h3>Latest News</h3>
      <div class="newlist">
        <swiper :options="swiperOption" ref="mySwiper" class="newswiper">
          <swiper-slide v-for="(item, index) in homelist" :key="index">
            <div class="swiper new" @click="toNewDetail(item.id)">
              <div class="swileft">
                <div class="ncf ndate">{{ item.date }}</div>
                <div class="ntitle">{{ item.title }}</div>
                <div class="ncf ncontent" style="overlfow:hidden">
                  {{ item.about }}
                </div>
              </div>
              <div
                class="csimg"
                :style="{
                  backgroundImage:
                    'url(' +
                    item.image +
                    '?x-oss-process=image/resize,m_fixed,w_640)'
                }"
              ></div>
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="prebtn"
          :class="{ curbtn: index == 0 }"
          @click="pre"
          style="color:#fff"
        >
          <div class="leftarrow" :class="{ whitebtn: index == 0 }"></div>
        </div>
        <div
          class="nextbtn"
          :class="{ curbtn: index == hlength }"
          @click="next"
          style="color:#fff"
        >
          <div class="rightarrow" :class="{ whitebtn: index == hlength }"></div>
        </div>
      </div>
    </div>
    <div class="story">
      <div>
        <img
          src="/static/img/about.jpg"
          alt="蓝鲨 Robor 智能电动摩托车"
          width="100%"
        />
      </div>
      <div class="stotips">
        <div class="stoname">Sharkgulf Technology</div>
        <div class="stocontent">
          Sharkgulf Tech is an international technology company that creates
          products and
        </div>
        <div class="stocontent">services of smart electric mobility.</div>
        <div class="stobtn ">
          <button @click="reaUs" class="btn">Learn more</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper1 from '../swiper_en/swiper1.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import utils from '../../utils/index'
export default {
  data() {
    const that = this
    return {
      index: 0,
      homelist: [],
      hlength: 0, // 新闻数目
      formore: false,
      swiperOption: {
        resistanceRatio: 0,
        // autoplay:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          transitionEnd: function() {
            that.index = this.activeIndex
          }
        }
      }
    }
  },
  components: {
    swiper,
    Swiper1,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    // console.log(this.swiper,"swiper")
    let that = this
    window.scrollTo(0, 0)
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
    this.getNews()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    },
    toNewDetail(id) {
      // this.$router.push({path:`/en/newsdetail/${id}`})
      this.$router.push('/en/newsdetail/' + id)
    },
    goProduct() {
      this.$router.push('/en/robor')
    },
    reaUs() {
      this.$router.push('/en/story')
    },

    expMore() {
      this.$router.push('/en/news')
    },
    getNews() {
      this.$source
        .post('/web/api/v1/article/homepage', {
          language: this.GLOBAL.language.english
        })
        .then(res => {
          if (res.data.state === '00') {
            let homelist = res.data.data
            let hlength = homelist.length - 1
            homelist.forEach((value, index) => {
              value.date = utils.getDate(value.date)
              // value.content=utils.dealArticle(value.content)
            })
            this.homelist = homelist
            this.hlength = hlength
          }
        })
    },
    pre() {
      this.swiper.slidePrev()
    },
    next() {
      this.swiper.slideNext()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.home {
  color: #fff;
  background: #000;
  padding-top: 60px;
  .product {
    position: relative;
    .gda {
      position: absolute;
      top: 75px;
      right: 22%;
    }
    .protips {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      .proname {
        font-size: 40px;
        margin-bottom: 12px;
        height: 48px;
        line-height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        .probg {
          font-size: 40px;
          font-weight: bold;
        }
      }
      .procontent {
        margin-bottom: 60px;
        height: 28px;
        line-height: 28px;
        font-size: 22px;
      }
      .probtn {
        width: 220px;
        font-size: 16px;
      }
      .proinfobox {
        width: 100%;
        background: rgba(255, 255, 255, 0.1);
        .proinfo {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 120px;
          width: 66.67%;
          margin: 0 auto;
          text-align: start;
          font-size: 24px;
          .arkride {
            position: relative;
            .arktm {
              position: absolute;
              top: 2px;
              left: 86px;
              font-size: 12px;
            }
            .arkright {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
  .news {
    padding: 5vw 0;
    width: 66.67%;
    margin: 0 auto;
    h3 {
      margin-bottom: 31px;
      font-size: 26px;
    }
    .newlist {
      position: relative;
      .prebtn {
        cursor: pointer;
        position: absolute;
        bottom: -12px;
        left: -17px;
        z-index: 10;
        width: 30px;
        height: 30px;
        padding: 5px 0 5px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .leftarrow {
          position: absolute;
          width: 10px;
          height: 10px;
          border-top: 2px solid #fff;
          border-left: 2px solid #fff;
          transform: rotate(-45deg);
        }
        .whitebtn {
          border-color: #666;
        }
      }
      .nextbtn {
        cursor: pointer;
        position: absolute;
        bottom: -12px;
        left: 28px;
        z-index: 10;
        width: 30px;
        height: 30px;
        padding: 5px 10px 5px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        .rightarrow {
          width: 10px;
          height: 10px;
          border-top: 2px solid #fff;
          border-right: 2px solid #fff;
          transform: rotate(45deg);
        }
        .whitebtn {
          border-color: #666;
        }
      }
      .curbtn {
        cursor: default;
      }
      .new {
        width: 100%;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        .swileft {
          margin-right: 5.7vw;
          max-height: 18.75vw;
          flex: 1;
          .ncf {
            font-size: 14px;
            color: #666;
          }
          .ncontent {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            line-height: 24px;
          }
          .ntitle {
            margin: 10px 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            line-height: 30px;
            font-size: 20px;
          }
          .ntitle:hover {
            color: @colorblue;
          }
        }
        // .nimg{
        //   img{
        //     height: 18.75vw;
        //   }
        // }
        .csimg {
          width: 59.26%;
          height: 18.75vw;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        }
      }
    }
    .more {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 12px;
      height: 20px;
      cursor: pointer;
      line-height: 20px;
      .arrow {
        margin-left: 12px;
        width: 8px;
        height: 8px;
        border-top: 1px solid #666;
        border-right: 1px solid #666;
        transform: rotate(45deg);
      }
      .arrowblue {
        border-top: 1px solid @colorblue;
        border-right: 1px solid @colorblue;
      }
    }
    .more:hover {
      color: @colorblue;
    }
  }
  .story {
    position: relative;
    text-align: center;
    .stotips {
      position: absolute;
      height: 230px;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .stoname {
        font-size: 48px;
        margin-bottom: 27px;
        font-weight: bold;
      }
      .stocontent {
        font-size: 18px;
        color: #fff;
        line-height: 36px;
      }
      .stobtn {
        padding: 25px 0;
        button {
          box-sizing: border-box;
          width: 240px;
          font-size: 18px;
          background: rgba(0, 0, 0, 0);
          color: #fff;
          outline: none;
        }
        button:hover {
          background: #fff;
          color: #000;
        }
      }
    }
  }
}
.home img {
  display: block;
}
.btn {
  box-sizing: border-box;
  height: 45px;
  border-radius: 23px;
  line-height: 41px;
  border: 2px solid #fff;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  background: #fff;
  color: #000;
}
.newswiper {
  --swiper-theme-color: #ff6600;
}
@media screen and (max-width: 1640px) {
  // .fs_normal{
  //   font-size: 20px;
  // }
  // .arktm{
  //   left: 70px!important;
  // }
  .proinfo {
    width: 1080px !important;
  }
  .news {
    width: 1080px !important;
  }
  .csimg {
    height: 280px !important;
  }
  // .csimg{
  //   height: 182px!important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/en/home.vue